import React, { useRef, useEffect, useState } from 'react';
import videoOverlay from '../../../assets/images/video-overlay.svg'
import { CardItemContainer } from './styles';
import AiOutlineHeart from '@meronex/icons/ai/AiOutlineHeart';
import AiFillHeart from '@meronex/icons/ai/AiFillHeart';
import Skeleton from 'react-loading-skeleton'

const CollectionCardItem = (props) => {
  const {
    item,
    onClick,
    isSkeleton
  } = props;

  const [isImage, setIsImage] = useState(true);

  const [isLiked, setIsLiked] = useState(false)

  const videoRef = useRef(null);

  const handlePlay = () => {
    if (videoRef) {
      videoRef?.current?.play()
        .catch(error => {
          console.log(error)
        })
    }
  }

  const handlePause = () => {
    if (videoRef) {
      videoRef?.current?.pause();
    }
  }

  useEffect(() => {
    setIsImage(item?.video === undefined || item?.video === false);
  }, [item])

  useEffect(() => {
    if (isImage || isSkeleton) return;
    if (videoRef) {
      videoRef?.current?.play()
        .catch(error => {
          console.log(error)
        })
    }
    const timer = setTimeout(function () {
      if (videoRef) {
        videoRef?.current?.pause()
      }
    }, 5000)
    return () => clearTimeout(timer)
  }, [isImage])

  return (
    <CardItemContainer>
      <div className="card-content">
        <div className="card-media" onClick={onClick}>
          {isSkeleton ? (
            <div className="card-image-container">
              <Skeleton height={230} />
            </div>
          ) : (
            <>
              {isImage ? (
                <div className="card-image-container">
                  <img src={item.tokenImage || '/videos/NFT-image.png'} alt="cardimage" />
                </div>
              ) : (
                <div className="card-video-container">
                  <video className="card-video"
                    ref={videoRef}
                    src={item.tokenImage}
                    muted
                  >
                    Your browser does not support playing videos.
                  </video>
                  <div
                    className="card-video-overlay"
                    onMouseOver={() => handlePlay()}
                    onMouseOut={() => handlePause()}
                  >
                    <img src={videoOverlay} alt="play" width="24" />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <div className='card-footer'>
          <div className="card-details">
            <div className="card-action-detail">
              {isSkeleton ? (
                <Skeleton width={60} height={14} />
              ) : (
                <div className='collection-name'>{item?.collectionName || 'COLLECTION NAME'}</div>
              )}
              {isSkeleton ? (
                <Skeleton width={60} height={14} />
              ) : (
                <>
                  <div className='nft-name'>{item?.tokenTitle || 'TOKEN TITLE'}</div>
                </>
              )}
            </div>
          </div>
          {isSkeleton ? (
            <Skeleton width={25} height={15} />
          ) : (
            <div className="card-favorite">
              <span
                className='icon'
                onClick={() => setIsLiked(true)}
              >
                {(isLiked || item?.favoriteCount > 0) ? <AiFillHeart /> : <AiOutlineHeart />}
              </span>
              <span>{item && item?.favoriteCount}</span>
            </div>
          )}
        </div>

        {item?.isMultiple && (
          <div className="card-multiple">
            <div className="multiple-tile-1"></div>
            <div className="multiple-tile-2"></div>
          </div>
        )}

      </div>
    </CardItemContainer>
  )
}

export default CollectionCardItem;